import { useEffect } from 'react';

// On auth screens (login / register / forgot / reset) the illustrated background should bleed
// edge-to-edge UNDER the status bar. The status bar is globally set to overlay the web view
// (App.js), and in-app pages get a top safe-area padding on .App. Here we simply add a body
// class that removes that padding so the auth background fills the whole screen.
export function useImmersiveStatusBar() {
  useEffect(() => {
    document.body.classList.add('auth-immersive');
    return () => { document.body.classList.remove('auth-immersive'); };
  }, []);
}
